import { Flex } from '@mantine/core';
import { DepartmentRow } from 'components/tables/data/department/types';
import BadgeDeleted from 'components/Badge';
import P2Medium from 'components/typography/P2Medium';
import DepartmentParentReference, {
  getDepartmentHierarchyDepth,
  HIERARCHY_DEPTH_INDENT,
} from 'components/department/DepartmentParentReference';
import useDepartmentUiMode from 'model/useDepartmentUiMode';

/**
 * Column for the department name.
 */
export default function DepartmentNameColumn({ data }: { data: DepartmentRow }) {
  const { mode } = useDepartmentUiMode();
  const { breadcrumbs = [], departmentName, status } = data;
  const depth = getDepartmentHierarchyDepth(breadcrumbs);
  const opacity = status ? 1 : 0.6;

  return (
    <Flex
      gap={10}
      align="center"
      style={{ paddingLeft: mode === 'tree' ? depth * HIERARCHY_DEPTH_INDENT : 0 }}
      data-hierarchy-depth={mode === 'tree' ? depth : 0}
    >
      {mode === 'tree' && <DepartmentParentReference breadcrumbs={breadcrumbs} />}
      {!status && <BadgeDeleted text="Vyradené" />}
      <P2Medium color="gray.8" style={{ opacity }}>
        {departmentName}
      </P2Medium>
    </Flex>
  );
}
